import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { getAccountUsername } from '../../../util/account';
import Button from '../Button';
import WarningIcon from '../../icons/WarningIcon';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  onContinue: PropTypes.func,
  onRequestClose: PropTypes.func,
};

const OutdatedAlbumFolder = ({
  albumFolder,
  onRequestClose,
  history,
  onContinue = onRequestClose,
}) => {
  const username = getAccountUsername(albumFolder?.account);
  const orgUrl = username ? `/@${username}` : '';

  return (
    <div className="d-flex flex-column justify-content-center align-items-center p-0 p-md-2">
      <WarningIcon color="#fe5851" className="mb-3" size={48} />
      <h3 className="text-center mb-3">
        You&apos;re trying to join{' '}
        <span className="text-primary">{albumFolder?.name}</span>, which is an
        outdated gallery!
      </h3>
      <p className="text-center mb-3">
        This event has not been updated in{' '}
        <span className="text-danger">over 90 days.</span> Are you sure you want
        to join this gallery?{' '}
        {orgUrl ? 'You can proceed or view more recent galleries below.' : ''}
      </p>
      <Button
        onClick={() => {
          onContinue();
          onRequestClose();
        }}
        btnBlock
        btnOutline={!!orgUrl}
        className="px-6"
      >
        Yes, I want to join this event
      </Button>
      {orgUrl && (
        <Button
          onClick={() => {
            history.push(orgUrl);
          }}
          btnBlock
          className="mt-2"
        >
          View recent events
        </Button>
      )}
    </div>
  );
};

OutdatedAlbumFolder.propTypes = propTypes;

export default withRouter(OutdatedAlbumFolder);
